module.exports = __webpack_public_path__ + "img/mug-tea-saucer.4e5250a1.svg";